import { render, staticRenderFns } from "./ExploreProjectsSection.vue?vue&type=template&id=1a2bce05"
import script from "./ExploreProjectsSection.vue?vue&type=script&lang=js"
export * from "./ExploreProjectsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports